import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconControlKeyRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconControlKeyRight"><Path fillRule="evenodd" clipRule="evenodd" d="M3 21V3H21V21H3ZM14 6.68934L10.6893 10L11.75 11.0607L14 8.81066L16.25 11.0607L17.3107 10L14 6.68934Z" fill="currentColor"/></CentralIconBase>;
});

export default IconControlKeyRight;
